import { API_BASE_URL, SERVICEURL, USERTYPES } from "../constants/Constants";
import axios from "axios";
import { APIs } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";
import { encryptData } from "../helpers/RSAUtility";

export const getAdminUserList = async (requestForRole, body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.USERLIST, {
      data: {
        requestForRole,
        paginationDto: body.paginationDto,
        firmId: body.firmId,
      },
    });
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const newUserData = async (addRequestForRole, firmId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.NEWUSER, {
      data: {
        addRequestForRole,
        firmId,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchEditUserData = async (userId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITUSER, {
      data: {
        userId,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addUser = async (userDto, firmId) => {
  const user = JSON.stringify(userDto);
  var formData = new FormData();
  const blob = new Blob([user], {
    type: "application/json",
  });

  formData.append("userDto", blob);
  if (firmId != null) {
    const blob2 = new Blob([firmId], {
      type: "application/json",
    });
    formData.append("firmId", blob2);
  }

  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ADDUSER,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editUser = async (userDto, firmId) => {
  const user = JSON.stringify(userDto);
  const profileUpdatePage = window.location.pathname.includes("/account-and-settings");
  var formData = new FormData();
  const blob = new Blob([user], {
    type: "application/json",
  });

  formData.append("userDto", blob);
  if (firmId != null) {
    const blob2 = new Blob([firmId], {
      type: "application/json",
    });
    formData.append("firmId", blob2);
  }

  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + `${profileUpdatePage?APIs.USERPROFILEUPDATE:APIs.UPDATEUSER}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addRadiologist = async (userDto, signatureImage) => {
  console.log("userDto : " + userDto);

  const user = JSON.stringify(userDto);

  console.log("user : " + user);
  var formData = new FormData();
  const blob = new Blob([user], {
    type: "application/json",
  });

  formData.append("userDto", blob);

  console.log(signatureImage);

  if (signatureImage != null) {
    formData.append("signatureFile", signatureImage);
  }

  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ADDUSER,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editRadiologist = async (userDto, signatureImage) => {
  console.log("userDto : " + userDto);

  const user = JSON.stringify(userDto);

  console.log("user : " + user);
  var formData = new FormData();
  const blob = new Blob([user], {
    type: "application/json",
  });

  formData.append("userDto", blob);

  console.log(signatureImage);

  if (signatureImage != null) {
    formData.append("signatureFile", signatureImage);
  }

  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATEUSER,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
    window.location.assign(APIs.REDIRECTLOGOUT);
  }
};

export const changeUserStatus = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.CHANGEUSERSTATUS,
      {
        data: {
          id,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const changeUserLockStatus = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.CHANGEUSERLOCKSTATUS,
      {
        data: {
          id,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const passwordResetByAdmin = async (username,password)=>{
try {
    const encryptedUsername=encryptData(username);
    const encryptedPassword=encryptData(password);
     const response = await axiosInterceptor.post( API_BASE_URL + APIs.PASSWORDRESET, {
      data: {
        username:encryptedUsername,
        password:encryptedPassword
      }
    });

    return response;
  } catch (error) {
      if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}
export const viewUser = async (id) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.VIEWUSER, {
      data: {
        id,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const viewProvider = async (providerId, type) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.VIEWPROVIDER,
      {
        data: {
          providerId,
          type,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSupervisorList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.USERLIST, {
      data: {
        requestForRole: USERTYPES.SUPERVISOR,
        paginationDto: body.paginationDto,
        firmId: body.firmId,
        firmAccessList: body.firmAccessList,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getFirmDoctorList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.USERLIST, {
      data: {
        requestForRole: USERTYPES.FIRMDOCTOR,
        paginationDto: body.paginationDto,
        firmId: body.firmId,
        firmAccessList: body.firmAccessList,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getFirmTechnicianList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.USERLIST, {
      data: {
        requestForRole: USERTYPES.FIRMTECHNICIAN,
        paginationDto: body.paginationDto,
        firmId: body.firmId,
        firmAccessList: body.firmAccessList,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getRadiologistList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.USERLIST, {
      data: {
        requestForRole: USERTYPES.RADIOLOGIST,
        paginationDto: body.paginationDto,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getProviderList = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PROVIDERLIST,
      {
        data: {
          paginationDto: body.paginationDto,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSignatureImage = async (imageName) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SIGNATUREIMAGE,
      {
        data: {
          imageName,
        },
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const changePassword = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.CHANGEPWD,
      {
        data: body,
      }
    );
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const userPreference = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.USERPREFERENCE,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveUserPreference = async (
  outline,
  heatmap,
  nonXrayAdvanceViewer,
  newBasicViewer,
  studylistSearchDateFilter,
  isActiveData,
  prefetchCount,
  cINEFramesPerSecond,
  twoMonitorEnabled,
  studylistOrderBy,
  noOfImagesFilter,
  userTimeZone,
  pdfPreviewPreference,
  autoSaveReport,
  autoOpenNoAbnormality,
  autoOpenFoOnly,
  autoOpenAbnormality,
  autoOpenNoAiDetection,
  autoPopulateManualPathology
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SAVEUSERPREFERENCE,
      {
        data: {
          outline,
          heatmap,
          nonXrayAdvanceViewer,
          newBasicViewer,
          isActiveData,
          studylistSearchDateFilter,
          prefetchCount,
          cINEFramesPerSecond,
          twoMonitorEnabled,
          studylistOrderBy,
          noOfImagesFilter,
          userTimeZone,
          pdfPreviewPreference,
          autoSaveReport,
          autoOpenNoAbnormality,
          autoOpenFoOnly,
          autoOpenAbnormality,
          autoOpenNoAiDetection,
          autoPopulateManualPathology,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const userProfile = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.USERPROFILE,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const loadSupportMembers = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.AVAILABLESUPPORTMEMBERS,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateOTP = async (username) => {
  try {
    const response = await axios.post(API_BASE_URL + APIs.GENERATEOTP, {
      data: {
        username,
      },
    });
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateOTP2FA = async (username) => {
  try {
    const response = await axios.post(API_BASE_URL + APIs.GENERATEOTP2FA, {
      data: {
        username,
      },
    });
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const authenticateOTP = async (username, otp) => {
  try {
    const response = await axios.post(API_BASE_URL + APIs.AUTHENTICATEOTP, {
      data: {
        forgotPassword: {
          username,
          otp,
        },
      },
    });
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const resetPassword = async (
  username,
  newPassword,
  confirmNewPassword
) => {
  try {
    const response = await axios.post(
      API_BASE_URL + APIs.RESETPASSWORD,
      {
        data: {
          resetPasswordDto: {
            username,
            newPassword,
            confirmNewPassword,
          },
        },
      }
    );
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const authenticateGoogleUser = async (email) => {
  try {
    const response = await axios.post(
      API_BASE_URL + APIs.AUTHENTICATEGOOGLEUSER,
      {
        email,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getUserInfo = async (access_token) => {
  console.log("in user info service call");
  const userInfo = await new Promise((resolve) => {
    const xhr = new XMLHttpRequest();

    xhr.open("GET", `https://www.googleapis.com/oauth2/v3/userinfo`);
    xhr.setRequestHeader("Authorization", `Bearer ${access_token}`);
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300)
        resolve(JSON.parse(this.responseText));
      else resolve({ err: "404" });
    };
    xhr.send();
  });
  console.log(userInfo);
  return userInfo;
};

export const logout = async () => {
  localStorage.removeItem("hasSession");
  localStorage.removeItem("theme");
  await axiosInterceptor.post(API_BASE_URL + "auth/signout");
};

export const updateUserSettings = async (userSettingJson,userId) => {
  try {
    const response = await axios.post(API_BASE_URL + SERVICEURL + APIs.USERSETTINGS, {
      data: {
        userSettings: JSON.stringify(userSettingJson),
        userId: userId
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getTypistList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.USERLIST, {
      data: {
        requestForRole: USERTYPES.TYPIST,
        paginationDto: body.paginationDto,
        firmId: body.firmId,
        firmAccessList: body.firmAccessList,
      },
    });

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getActiveSessions = async () => {
  try {
    const response = await axiosInterceptor.get(API_BASE_URL + APIs.GET_ACTIVE_SESSIONS);
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

// ✅ Logout specific session
export const logoutSession = async (token) => {
  try {
    const response = await axiosInterceptor.post(`${API_BASE_URL + APIs.LOGOUT_SESSION}/${token}`);
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
export const forceLogoutAllSessions = async (username) => {
  localStorage.removeItem("hasSession");
  localStorage.removeItem("theme");
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "auth/forceLogout",
      {
        data: {
          forceLogoutDto: {
            username: username,
            unassignStudies: false,
            logoutAllSessions: true,
          },
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
